<template>
    <FullCalendar ref="csm__project__calendar" :options="{...calendarOptions, events: calendarEvents}">
      <template v-slot:eventContent='arg'>
        <span v-html="arg.event.extendedProps.deliverable + ' > ' + arg.event.title" v-if="(typeof arg.event.extendedProps.deliverable != 'undefined')" @click="handleEventTitleClick(arg)"></span>
        <span v-else v-html="arg.event.title" @click="handleEventTitleClick(arg)"></span>
      </template>
      <template v-slot:dayCellContent='arg'>
        <a id="fc-dom-4" class="fc-daygrid-day-number" :aria-label="$moment(arg.date).format('MMMM DD, YYYY')">{{arg.dayNumberText}}</a>
        <a v-if="$moment.utc(arg.date).isSame($moment.utc(expandDate), 'day')" class="fc-event-hide" title="Collapse" @click.prevent="handleHideClick(arg)">Collapse</a>
      </template>
    </FullCalendar>
</template>

<script>
import '@fullcalendar/core/vdom' // solves problem with Vite
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },
  computed: {
    ...mapGetters(['projectDeliverables', 'deliverableDetail']),
    calendarEvents() {
        let events = []
        const targetDate = this.expandDate ? this.$moment(this.$moment.utc(this.expandDate).format("YYYY-MM-DD"), "YYYY-MM-DD") : null;
        this.projectDeliverables.forEach((projectDeliverable) => {
          let eventStartDate = projectDeliverable.created_at;
            const startDateField = projectDeliverable.customFields.filter(x => x.field_key == 'start_date');
            if (startDateField && startDateField.length > 0 && startDateField[0]['value']) {
              eventStartDate = startDateField[0]['value']
            }

            if (targetDate) {
              const startDate = this.$moment(eventStartDate);
              const endDate = this.$moment(projectDeliverable.due_date ? projectDeliverable.due_date : projectDeliverable.created_at);
              if (!targetDate.isBetween(startDate, endDate, 'day', '[]')) return;
            }

            events.push({
                id: projectDeliverable.id,
                title: projectDeliverable.title,
                start: this.$moment(eventStartDate).format("YYYY-MM-DD"),
                end: projectDeliverable.due_date ? this.$moment(projectDeliverable.due_date).add(1, 'days').format("YYYY-MM-DD") : this.$moment(projectDeliverable.created_at).add(1, 'days').format("YYYY-MM-DD"),
                allDay: false,
                backgroundColor: '#4C9850'
            })
        })
        return events
    },
  },
  data() {
    let self = this
    return {
        events: [],
        calendarOptions: {
            plugins: [
            dayGridPlugin,
            timeGridPlugin,
            resourceTimelinePlugin,
            interactionPlugin // needed for dateClick
            ],
            customButtons: {
              collapseButton: {
                text: 'Collapse',
                click: () => {
                  this.handleHideClick(this.$refs.csm__project__calendar.getApi());
                }
              }
            },
            headerToolbar: {
            left: 'prev,next today',
            center: 'title',
            right: 'collapseButton timelineYearView,dayGridMonth,dayGridBiWeekly,dayGridWeek,dayGridDay'
            },
            views: {
            dayGridBiWeekly: {
                type: 'dayGrid',
                duration: { weeks: 2 },
                buttonText: 'Bi-Weekly'
            },
              timelineYearView: {
              type: 'timeline',
              duration: { year: 1 },
              slotDuration: { month: 1 },
              dateIncrement: { year: 1 },
              buttonText: 'Year',
            },
            },
            initialView: 'dayGridBiWeekly',
            // eventSources: [{
            //   events(start, callback) {
            //     self.$store.dispatch('getCalendarData').then((response) => {
            //       callback(response.data)
            //     })
            //   }
            // }],
            editable: false,
            selectable: false,
            selectMirror: true,
            dayMaxEvents: true,
            weekends: true,
            select: this.handleDateSelect,
            eventClick: this.handleEventClick,
            eventMouseEnter: this.handleEventMouseEnter,
            eventMouseLeave: this.handleEventMouseLeave,
            eventClassNames: 'mb-2',
            moreLinkClick: this.handleMoreLinkClick,
            /* you can update a remote database when these fire:
            eventAdd:
            eventChange:
            eventRemove:
            */
        },
        expandDate: null,
    }
  },
  mounted() {
    // this.getCalendarData(this.dataSetType)

    $(".fc-collapseButton-button").attr("disabled", true);
  },
  methods: {
    ...mapActions(['getCalendarData']),
    createEventId() {
      let eventGuid = 0
      return String(eventGuid++)
    },

    handleDateSelect(selectInfo) {
      let title = prompt('Please enter a new title for your event')
      let calendarApi = selectInfo.view.calendar

      calendarApi.unselect() // clear date selection

      if (title) {
        calendarApi.addEvent({
          id: this.createEventId(),
          title,
          start: selectInfo.startStr,
          end: selectInfo.endStr,
          allDay: selectInfo.allDay
        })
      }
    },

    handleEventClick(clickInfo) {
      let existingEvents = clickInfo.view.calendar.getEvents();
      existingEvents.forEach(x => {
        x.setProp("classNames", []);
      });
      clickInfo.event.setProp("classNames", ['selected']);
    },

    handleEventTitleClick(clickInfo) {
      let deliverableId = clickInfo.event.groupId != '' ? clickInfo.event.groupId : clickInfo.event.id
        this.$store
            .dispatch("getDeliverableDetail", { deliverableId })
            .then(() => {
                let currentTitle = document.title.match(/\(\d+\)\s/g);
                if(!currentTitle) {
                    document.title = this.deliverableDetail.title;
                } else {
                    document.title = currentTitle[0] + this.deliverableDetail.title;
                }
                this.$bvModal.show("editDeliverableModal");
            });
    },

    handleEventMouseEnter(mouseInfo) {
      const classArray = Object.assign([], mouseInfo.event.classNames || []);
      classArray.push('hover');
      mouseInfo.event.setProp("classNames", classArray);
    },
    handleEventMouseLeave(mouseInfo) {
      const classArray = Object.assign([], mouseInfo.event.classNames || []);
      const newClassArray = classArray.filter(x => x != 'hover');
      mouseInfo.event.setProp("classNames", newClassArray);
    },

    handleMoreLinkClick(clickInfo) {
      if (this.calendarOptions.dayMaxEvents === true) {
        this.calendarOptions.dayMaxEvents = clickInfo.allSegs.length;
      } else {
        this.calendarOptions.dayMaxEvents += clickInfo.hiddenSegs.length;
      }
      this.renderCount = 2;
      return clickInfo.view.type;
    },

    handleMoreLinkClick(clickInfo) {
      this.expandDate = clickInfo.date;
      this.calendarOptions.dayMaxEvents = clickInfo.allSegs.length;
      $(".fc-collapseButton-button").attr("disabled", false);
      return clickInfo.view.type;
    },

    handleHideClick(info) {
      this.calendarOptions.dayMaxEvents = true;
      this.expandDate = null;
      $(".fc-collapseButton-button").attr("disabled", true);
      // info.view.calendar.render();
    },
  }
}
</script>

<style>

</style>